// Generated by scripts/sync-version.mjs. Do not edit.
export const VERSION = "0.8.0";
